import React from 'react'
import Banner from '../Banner'
import GalleryComponent from '../Components/GalleryComponent'
import ReactGA from 'react-ga';
import {Redirect} from 'react-router-dom'
import {FacebookShareButton, WhatsappShareButton, EmailShareButton, TwitterShareButton} from 'react-share'
import {FacebookIcon, TwitterIcon, WhatsappIcon, EmailIcon} from 'react-share';
import {data} from '../../const/data'

ReactGA.initialize('UA-144557614-1');

const PropertyTitle = ({name, address, neighborhood, city}) => {
	return(
	<div className="col-xl-8 sl-title" style={{padding: "0px"}}>
		<h2>{name}</h2>
		<p><i className="fa fa-map-marker-alt"><a href="#map-canvas" style={{color: "inherit"}}>  {address} - {neighborhood} - {city}</a></i></p>
	</div>
	);
}

const PropertyDetail = ({icon, detail_item}) => {

	if(detail_item !== ""){
		switch(icon) {
			case "car": return(<p style={{marginBottom: "0px"}}><i className="fa fa-car"></i> Estacionamento: {detail_item}</p>);
			case "air_conditioning": return(<p style={{marginBottom: "0px"}}><i className="fa fa-temperature-low"></i> Ponto de Ar Condicionado: {detail_item}</p>);
			case "balcony": return(<p style={{marginBottom: "0px"}}><i className="fa fa-glass-cheers"></i> {detail_item}</p>);
			default: return(null);
	   }
		   
	}
	else return null;
	
}

const PropertyOptions = ({number, type, bedroom, washroom }) => {
	return (
		<div className="details-options" style={{border:"solid #f7f7f9", borderWidth:"0.25rem", width: "100%", marginBottom:"8px"}}>
			<div style={{marginLeft: "12px"}}>
			<p style={{marginBottom: "10px", width:"100%", fontWeight: "700"}}>Opção {number}</p>
			{ type !== "" &&  <p style={{marginBottom: "0px", width:"100%"}}><i className="fa fa-th-large"></i> {type}</p>}	
			{ bedroom !== "" &&  <p style={{marginBottom: "0px", width:"100%"}}><i className="fa fa-bed"></i> {bedroom}</p> }
			{ washroom !== "" &&  <p style={{marginBottom: "0px", width:"100%"}}><i className="fa fa-bath"></i> {washroom}</p>}
			</div>
		</div>

	);
}

const AmenitiesList = ({amenitiesData}) => {

	return(
		<p><i className="fa fa-check-circle-o"></i>  {amenitiesData}</p>
	);
}

const VideoComponent = ({videoUrl}) => {
	if(videoUrl !== ""){
		return(
			<div>
			<h3 className="sl-sp-title topic">Video</h3>
			<div className="perview-video">
				<iframe style={{width:"100%", height:"auto", frameborder:"0"}} src={videoUrl} />
			</div>
			</div>
		);
	}else{
		return null;
	}

}

const LinkComponent = ({links}) => {
	return (
		<div style={{display: "block", width: "100%"}}>
			<a href={links} style={{width: "100%", overflowWrap: "break-word", wordWrap: "break-word", wordBreak: "break-word"}} >{links}</a>
		</div>
	);

}

const SetMapsPosition = ({place}) => {

	const key = `${process.env.REACT_APP_MAPS}`;
	const src_url = "https://www.google.com/maps/embed/v1/place?q=place_id:" + place + "&key=" + key;
	return (
		<iframe style={{width: "100%", height: "300px", frameborder:"0", border:"0" }} src={src_url}></iframe>
	);

}

const PriceComponent = ({priceValue, description}) => {

	return (
		<div className="text-center" style={{width: "100%"}}>
			<p style={{marginBottom: "5px"}}>{description}</p>
			<button style={{marginTop: "0px", background: "#30caa0", color: "#fff"}}type="button" className="btn btn-success contact-me" data-toggle="modal" data-target="#modalCenter">{priceValue}</button>
		</div>
	);

}

function chunkArray(arr, n){
	var rest = arr.length % n, // how much to divide
	restUsed = rest, // to keep track of the division over the elements
	partLength = Math.floor(arr.length / n),
	result = [];

for(var i = 0; i < arr.length; i += partLength) {
	var end = partLength + i,
		add = false;

	if(rest !== 0 && restUsed) { // should add one element for the division
		end++;
		restUsed--; // we've used one division element now
		add = true;
	}

	result.push(arr.slice(i, end)); // part of the array

	if(add) {
		i++; // also increment i in the case we added an extra element for division
	}
}

return result;
}

function initializeGA(){
    ReactGA.pageview(window.location.pathname);
}

function interaction({mCategory, mType}){
	ReactGA.event({
		category: mCategory,
		action: mType, 

	});
}

export default class PropertyPage extends React.Component {


	constructor(props){
		super(props);
		if(this.props.location.state !== undefined){
			this.obj = this.props.location.state;

		}else{
			const localData =  data.filter(x => x.name===this.props.match.params.slug);
			this.obj = [{params: localData[0]}][0];
		}		
	}

	componentDidMount() {
		window.scrollTo(0, 0);
		initializeGA();
    }



	render(){

		if(this.obj.params===undefined){
			return <Redirect to='/not-found' />;
		}
		
		const bannerUrl = this.obj.params.banner_url;
		const amenitiesArr = this.obj.params.property_amenities;
		const arr = chunkArray(amenitiesArr, 3);

		return (
			<div>
				<Banner backgroundImage={`url(${process.env.PUBLIC_URL}/${bannerUrl})`}/>
				<br />
		
				<div className="container">

					<div className="row">

					<div className="col-sm">
					<PropertyTitle name={this.obj.params.title} address={this.obj.params.address} neighborhood={this.obj.params.neighborhood} city={this.obj.params.city}/>
						
					<p style={{marginBottom: "0px"}}>Compartilhe:</p>

						<ul style={{listStyleType: "none", padding: "0px"}}>
							<li style={{display: "inline-block", margin:"5px"}}><FacebookShareButton url={"https://www.pauloymamura.com.br/imoveis/"+ this.obj.params.name}><FacebookIcon round={true} size={32} onClick={()=>interaction("share", "facebook")}/></FacebookShareButton></li>
							<li style={{display: "inline-block", margin:"5px"}}><WhatsappShareButton url={"https://www.pauloymamura.com.br/imoveis/"+ this.obj.params.name} ><WhatsappIcon round={true} size={32} onClick={()=>interaction("share", "whatsApp")}/></WhatsappShareButton></li>
							<li style={{display: "inline-block", margin:"5px"}}><EmailShareButton url={"https://www.pauloymamura.com.br/imoveis/"+ this.obj.params.name}>	<EmailIcon round={true} size={32} onClick={()=>interaction("share", "email")}/></EmailShareButton></li>
							<li style={{display: "inline-block", margin:"5px"}}><TwitterShareButton url={"https://www.pauloymamura.com.br/imoveis/"+ this.obj.params.name}><TwitterIcon round={true} size={32} onClick={()=>interaction("share", "twitter")}/></TwitterShareButton></li>
						</ul>
	
					</div>	
					<div className="col-sm-4">
						<PriceComponent priceValue={this.obj.params.price} description={this.obj.params.price_description} onClick={() => interaction("check", "price")}/>
					</div>
					

					</div>
						
						

						{/* Modal */}
						<div className="modal fade" id="modalCenter" tabIndex={-1} role="dialog" aria-labelledby="modalCenterTitle" aria-hidden="true">
						<div className="modal-dialog modal-dialog-centered" role="document">
							<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title" id="exampleModalLongTitle">Saiba mais</h5>
								<button type="button" className="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">×</span>
								</button>
							</div>
							<div className="modal-body">
								Ligue para <a href="tel: +55 11 99152-1740" onClick={()=>interaction("contact-imovel", "phone")}>(11) 99152-1740</a> para maiores informações ou mande um e-mail para <a href={"mailto:paulo_ymamura@hotmail.com?Subject=Interesse%20no%20apartamento%20"+this.obj.params.title} onClick={()=>interaction("contact", "email")}>paulo_ymamura@hotmail.com</a>
								<p>Tratar com Paulo Ymamura</p>
							</div>
							<div className="modal-footer">
								<button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button>
								{/* <button type="button" className="btn btn-primary">Save changes</button> */}
							</div>
							</div>
						</div>
						</div>


					

	

					<div className="single-list-content">
						<div className="row">
							<div className="col-sm gallery">
								<GalleryComponent  gallery_item={this.obj.params.name}/>
								<div className="text-center">
									<button type="button" className="btn btn-primary contact-me" data-toggle="modal" data-target="#modalCenter" onClick={()=>interaction("contact", "click")}>
								Entre em contato</button>
								</div>
							
							</div>
		
							<div className="col-sm">
								<h3 className="sl-sp-title">Detalhes e opções</h3>
									
								<div className="col-sm" style={{marginBottom: "16px"}}>
										<PropertyDetail icon="car" detail_item={this.obj.params.property_details[0].car}/>
										<PropertyDetail key="air_conditioning" icon="air_conditioning" detail_item={this.obj.params.property_details[1].air_conditioning}/>
										<PropertyDetail key="balcony" icon="balcony" detail_item={this.obj.params.property_details[2].balcony}/>

								</div>
		
								<div className="col-sm">

									{this.obj.params.property_options.map(obj => <PropertyOptions key={obj.options_id} number={obj.options_id} type={obj.type} bedroom={obj.bedroom} washroom={obj.washroom}/>)}

								</div>
							</div>             
						</div>

					</div>
		
			   		<div>
					<h3 className="sl-sp-title topic" >Descrição</h3>
					<div className="description">
						<p>{this.obj.params.description}</p>
					</div>
					</div>


					<div>
					<h3 className="sl-sp-title topic">Lazer e Facilidades</h3>
					<div className="row property-details-list">
						{arr[0].map((a, i) => <div key={"a"+i} className="col-md-4 col-sm-6"><AmenitiesList key={100+i} amenitiesData={a}/></div>)}
						{arr[1].map((a, i) => <div key={"b"+i} className="col-md-4 col-sm-6"><AmenitiesList key={200+i} amenitiesData={a}/></div>)}
						{arr[2].map((a, i) => <div key={"c"+i} className="col-md-4 col-sm-6"><AmenitiesList key={300+i} amenitiesData={a}/></div>)}
					</div>
					</div>

					<VideoComponent videoUrl={this.obj.params.video_url} onClick={()=>interaction("video", "facebook")}/>
		
					
		
				<h3 className="sl-sp-title topic">Location</h3>
					<div className="pos-map" id="map-canvas">
						<SetMapsPosition place={this.obj.params.place_id} onClick={()=>interaction("maps", "location")}/>
					</div>
				
				<h3 className="sl-sp-title topic">Links</h3>
					
				{this.obj.params.links.map((u, i) => <LinkComponent key={i} links={u} onClick={()=>interaction("links", "more information")}/> )}
						
			</div>
		</div>
		
		);
	}
}





// WEBPACK FOOTER //
// ./src/common/Property/index.jsx